/**
 * Copyright 2018 Phenix Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([
    'phenix-web-lodash-light'
], function(_) {
    var Assert = function() {

    };

    Assert.prototype.isObject = function isObject(obj, name) {
        Assert.prototype.isString('name', name);

        if (!_.isObject(obj)) {
            throw new Error('"' + name + '" must be an object. Received [' + typeof obj + ']');
        }
    };

    Assert.prototype.isArray = function isArray(array, name) {
        Assert.prototype.isString('name', name);

        if (!_.isArray(array)) {
            throw new Error('"' + name + '" must be an array. Received [' + typeof array + ']');
        }
    };

    Assert.prototype.isString = function isString(string, name) {
        if (!_.isString(name)) {
            throw new Error('"name" must be a string. Received [' + typeof name + ']');
        }

        if (!_.isString(string)) {
            throw new Error('"' + name + '" must be a string. Received [' + typeof string + ']');
        }
    };

    Assert.prototype.isBoolean = function isBoolean(bool, name) {
        Assert.prototype.isString('name', name);

        if (!_.isBoolean(bool)) {
            throw new Error('"' + name + '" must be a boolean. Received [' + typeof bool + ']');
        }
    };

    Assert.prototype.isNumber = function isNumber(number, name) {
        Assert.prototype.isString('name', name);

        if (!_.isNumber(number)) {
            throw new Error('"' + name + '" must be a number. Received [' + typeof number + ']');
        }
    };

    Assert.prototype.isFunction = function isFunction(callback, name) {
        Assert.prototype.isString('name', name);

        if (!_.isFunction(callback)) {
            throw new Error('"' + name + '" must be a function. Received [' + typeof callback + ']');
        }
    };

    // TODO (dcy) remove once all dependencies have been updated
    Assert.prototype.stringNotEmpty = function stringNotEmpty(string, name) {
        Assert.prototype.isStringNotEmpty(string, name);
    };

    Assert.prototype.isStringNotEmpty = function stringNotEmpty(string, name) {
        Assert.prototype.isString('name', name);
        Assert.prototype.isString(string, name);

        if (string === '') {
            throw new Error('"' + name + '" must not be empty');
        }
    };

    Assert.prototype.isInstanceOf = function(object, clazz, name) {
        Assert.prototype.isString('name', name);

        if (!_.isObject(object)) {
            throw new Error('"' + name + '" must be an instance. Received [' + typeof object + ']');
        }

        if (!(object instanceof clazz)) {
            throw new Error('"' + name + '" must be a valid instance of class ' + _.get(clazz, ['name'], 'undefined'));
        }
    };

    Assert.prototype.isNotUndefined = function(value, name) {
        Assert.prototype.isString('name', name);

        if (_.isUndefined(value)) {
            throw new Error('"' + name + '" must not be undefined');
        }
    };

    Assert.prototype.isValidType = function(type, types, name) {
        Assert.prototype.isStringNotEmpty(name, 'name');

        var typeName = _.getEnumName(types, type);

        if (_.isNullOrUndefined(typeName)) {
            throw new Error('"' + name + '" must be a valid type. Unable to locate type [' + type + ']');
        }

        return typeName;
    };

    Assert.prototype.isArrayOfString = function(value, name) {
        Assert.prototype.isString(name, 'name');
        Assert.prototype.isArray(value, name);

        _.forEach(value, function(val, key) {
            Assert.prototype.isString(val, name + '[' + key + ']');
        });
    };

    return new Assert();
});